import React, { Component } from 'react';
import store from '../store';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import DoneIcon from '@material-ui/icons/Done';

import createHistory from 'history/createBrowserHistory';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import { Link } from 'react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import TopBar from '../components/TopBar';

import { Redirect } from 'react-router-dom';

import firebase from "firebase/app";
import "firebase/firestore";
import _ from 'lodash'
import LessonComp from "../components/LessonComp"
import ButtonBase from '@material-ui/core/ButtonBase';
import ArrowBackIcon from '@material-ui/icons/ChevronLeft';

import * as STATIC from '../config/static';
const provinceList = [{ label: "Ho Chi Minh City", value: 'hcm' }
  , { label: "Ha Noi City", value: 'hn' }
  , { label: "Other", value: 'other' }
]
const agencyList = {
  hcm: [{ label: "Superbrain District 2", value: 'sd2' }
    , { label: "Superbrain Binh Tan ", value: 'sbt' }
  ],
  hn: [{ label: "Superbrain Ba Đình ", value: 'sbd' }
  ]
}

function searchLabel(array, value) {
  let rel = '';
  let index = array.findIndex(a => a.value == value);
  if (index > -1) {
    rel = array[index].label;
  }
  return rel;
}
let _this;
class Trial extends Component {
  constructor() {
    super();
    _this = this;
    this.state = { wWidth: 0, wHeight: 0, message: '', showSignUp: true,DATAS:[],Provines:[],name:'',email:'',phone:'',otherProvince:'', province: '', agency: '', submitted: false };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  handleChange = name => event => {

    event.preventDefault();
    this.setState({
      [name]: event.target.value

    });


  }

  handleDelete = (name, value) => {
    let change = _this.state[name];
    //console.log(name,value,change);
    change = _.without(change, value);
    //  console.log(change);
    this.setState({
      [name]: change
    });
  }
  componentWillMount(){
    this.loadData();
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  async loadData(){
    let res = await STATIC.postFormData(STATIC.API_FETCHURL,{url:'http://45.119.82.38:9090/api/agents?time=2001-01-01'});
    let DATAS = [];
    let Provines = [];
    console.log(res);
    if(res && res.data)
    {
      DATAS = res.data.filter(t=>t.tinh!=""&&t.tinh!=null&&t.enable==1);

      let tObj = _.groupBy(DATAS,'tinh');
      for(let key of Object.keys(tObj))
      {
        let item = {label:key,value:key};
        Provines.push(item);
      }
      Provines = _.sortBy(Provines,['label']);
      Provines.push({label:'Khác',value:'khac'});
      DATAS = tObj;
    }
    _this.setState({DATAS,Provines});
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }



  onLessonEnd(questions) {
    console.log(questions);
    let count = 0;
    let countCorrect = 0;
    for (let q of questions) {
      if (q.status) {
        count++;
        if (q.status == 1) {
          countCorrect++;
        }
      }
    }
    if (count == countCorrect && count == questions.length) {
      _this.setState({ showSignUp: true });
    }
  }

  async submitForm(e) {
    e.preventDefault();
    let {province,agency,name,email,phone,otherProvince} = _this.state;
    if(!name||name.trim().length==0)
    {
      STATIC.NotificationManager.error(_this.props.t('trial.enter_name'));
      return;
    }
    if(!email||email.trim().length==0||!STATIC.validateEmail(email))
    {
      STATIC.NotificationManager.error(_this.props.t('trial.enter_email'));
      return;
    }
    if(!phone||phone.trim().length==0||phone.trim().length<5)
    {
      STATIC.NotificationManager.error(_this.props.t('trial.enter_phone'));
      return;
    }
    if(!province||province.trim().length==0)
    {
      STATIC.NotificationManager.error(_this.props.t('trial.select_city'));
      return;
    }
    if(province!='khac' && (!agency || agency==0))
    {
      STATIC.NotificationManager.error(_this.props.t('trial.select_agency'));
      return;
    }
    if(province=='khac' && (!otherProvince || otherProvince.trim().length==0))
    {
      STATIC.NotificationManager.error(_this.props.t('trial.enter_city'));
      return;
    }
     let item = {ten:name,email,dienthoai:phone,idchinhanh:1,diachi:''};
     if(province!='khac')
     {
       item.idchinhanh = agency;
     }
     else {
       item.diachi = otherProvince;
     }
     console.log(item);
     await _this.setState({loading:true});
     let res = await STATIC.postFormData(STATIC.API_USER_ADDGUEST,{...item});
     if(res && res.status==1)
     {
       _this.setState({ submitted: true });
     }
     else if(res && res.status==2)
     {
       STATIC.NotificationManager.error(_this.props.t('trial.user_exist'));
     }
     else {
       STATIC.NotificationManager.error(_this.props.t('trial.try_again'));
     }
     await _this.setState({loading:false});

  }
  backClick() {
    this.props.history.push('/');
  }

  render() {
    const { classes,t } = this.props;
    const { wWidth, showSignUp, message, phone, email, province, agency, otherProvince, submitted, name,Provines,DATAS } = this.state;
    let width = STATIC.DWIDTH - 10;
    if (wWidth < STATIC.DWIDTH) {
      width = wWidth - 10;
    }
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;

    let temp_agencyList = null;
    if (province && province != "Khác")
    {

      temp_agencyList = DATAS[province];
      console.log(temp_agencyList);
    }
    return (
      <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
<TopBar width={width} />
          <Link to={'/'} style={{ position: "absolute", width: "100%", bottom: 5, left: 5 }}>
            <img src="/assets/web/logo_trans.png" style={{ width: STATIC.calSize(189, STATIC.DWIDTH, width), height: "auto" }} />
          </Link>
          {!showSignUp ? (<div className={classes.square} elevation={4}>
            <Grid container direction="row" alignItems="center" justify="center">
              <Grid item xs style={{ margin: '20px 20px', position: 'relative' }}>


                <p style={{ textAlign: "center", width: width * 0.8, paddingLeft: width * 0.1, margin: 0, fontSize: width * 0.085 }}>Superbrain Trial</p>
                <ButtonBase
                  focusRipple
                  onClick={() => this.backClick()}
                  style={{ position: 'absolute', top: 5, left: 0, backgroundColor: 'rgba(0,0,0,0.3)', padding: '5px 5px', borderRadius: 10, color: 'white', lineHeight: 0.7 }}>
                  <ArrowBackIcon style={{ fontSize: width * 0.065 }} />
                </ButtonBase>
              </Grid>
            </Grid>
            <Divider style={{ marginTop: 5, marginBottom: 10, backgroundColor: "#538234", height: 2 }} variant="middle" />
            <div style={{ display: 'block', height: 5 }} />
            <LessonComp
              type={['image', 'LB_1', 'LB_-1', 'LB_2', 'LB_-2', 'LB_3', 'LB_-3']}
              rows={3}
              showTime={6}
              answerTime={10}
              qCount={2}
              maxNumber={10}
              displaySetting={false}
              displayShow={true}
              onLessonEnd={this.onLessonEnd}
            />

          </div>) : false}
          {showSignUp && !submitted ? (<div className={classes.square} elevation={4}>
            <Grid container direction="row" alignItems="center" justify="center">
              <Grid item xs>
                <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontWeight: 'bold', fontFamily: 'UTMP', fontSize: fLarge }}>
                  {t('trial.title1')}
                            </div>
                <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', fontSize: fTitle }} dangerouslySetInnerHTML={{__html: t('trial.title2')}}>

</div>

              </Grid>
            </Grid>
            <div style={{ display: 'block', height: 5 }} />

            <div>
              <Grid container >
                <Grid item xs={12} sm={6} style={{ padding: '0px 0px 0px ' + STATIC.calSize(10, STATIC.DWIDTH, width) + 'px', marginBottom: 10 }}>

                  <input
                    onChange={this.handleChange('name')}
                    value={name}
                    type="text"
                    placeholder={t('trial.f_name')}
                    style={{ border: 'none', height: STATIC.calSize(65, STATIC.DWIDTH, width), width: '100%', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(5, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(30, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                </Grid>
                <Grid item xs={12} sm={6} style={{ padding: '0px 0px 0px ' + STATIC.calSize(10, STATIC.DWIDTH, width) + 'px', marginBottom: 10 }}>

                  <input
                    onChange={this.handleChange('email')}
                    value={email}
                    type="text"
                    placeholder={t('trial.f_email')}
                    style={{ border: 'none', height: STATIC.calSize(65, STATIC.DWIDTH, width), width: '100%', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(5, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(30, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                </Grid>
                <Grid item xs={12} sm={6} style={{ padding: '0px 0px 0px ' + STATIC.calSize(10, STATIC.DWIDTH, width) + 'px', marginBottom: 10 }}>

                  <input
                    onChange={this.handleChange('phone')}
                    value={phone}
                    type="phone"
                    placeholder={t('trial.f_phone')}
                    style={{ border: 'none', height: STATIC.calSize(65, STATIC.DWIDTH, width), width: '100%', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(5, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(30, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                </Grid>
                <Grid item xs={12} sm={6} style={{ padding: '0px 0px 0px ' + STATIC.calSize(10, STATIC.DWIDTH, width) + 'px', marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <FormControl variant="filled" style={{ backgroundColor: 'white', height: STATIC.calSize(65, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), width: "100%" }}>

                    <Select

                      value={province}
                      onChange={this.handleChange('province')}
                      displayEmpty

                      style={{ padding: (STATIC.calSize(20, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px'), height: STATIC.calSize(65, STATIC.DWIDTH, width), fontSize: fNormal, width: "100%",border:'none' }}
                    >
                      <MenuItem value="" disabled>
                        {t('trial.f_city')}
                      </MenuItem>
                      {Provines.map((t, index) => {
                        return (<MenuItem key={"province" + index} value={t.value}>
                          {t.label}
                        </MenuItem>)
                      })}
                    </Select>
                  </FormControl>
                </Grid>

                {temp_agencyList != null ? <Grid item xs={12} style={{ padding: '0px 0px 0px ' + STATIC.calSize(10, STATIC.DWIDTH, width) + 'px', marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <FormControl variant="filled" style={{ backgroundColor: 'white', height: STATIC.calSize(65, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), width: "100%" }}>

                    <Select

                      value={agency}
                      onChange={this.handleChange('agency')}
                      displayEmpty

                      style={{ padding: (STATIC.calSize(20, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px'), height: STATIC.calSize(65, STATIC.DWIDTH, width), fontSize: fNormal, width: "100%",border:'none' }}
                    >
                      <MenuItem value="" disabled>
                        {t('trial.f_select_agency')}
        </MenuItem>
                      {temp_agencyList.map((t, index) => {
                        return (<MenuItem key={"province" + index} value={t.id}>
                          <p style={{fontSize:fNormal}}>{t.ten}<br/><span style={{fontSize:fSmall}}>{t.diachi}</span></p>
                        </MenuItem>)
                      })}
                    </Select>
                  </FormControl>

                </Grid> :
                  province ? (<Grid item xs={12} sm={6} style={{ padding: '0px 0px 0px ' + STATIC.calSize(10, STATIC.DWIDTH, width) + 'px', marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>

                    <input
                      onChange={this.handleChange('otherProvince')}
                      value={otherProvince}
                      type="text"
                      placeholder={t('trial.f_enter_city')}
                      style={{ border: 'none', height: STATIC.calSize(65, STATIC.DWIDTH, width), width: '100%', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(5, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(30, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />


                  </Grid>) : false}
                <Grid item xs={12} style={{ textAlign: 'center', marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <Button disabled={this.state.loading} style={{ color: "white", width: "50%",fontSize:fNormal,backgroundColor: '#8dc63f' }} color="primary" size="large" variant="contained" onClick={(e)=>this.submitForm(e)} >
                    {t('trial.submit')}
                                </Button>
                </Grid>
              </Grid>
            </div>

          </div>) : showSignUp && submitted ? (<div className={classes.square} elevation={4}>
            <Grid container direction="column" alignItems="center" justify="center">
              <Grid item xs>

                <p style={{ fontSize: '2rem', textAlign: 'center', color: 'rgb(5, 63, 34)' }}>{t('trial.thank_you')}</p>
                <Divider style={{ marginTop: 5, marginBottom: 10, backgroundColor: "#538234", height: 2 }} variant="middle" />
              </Grid>
              <Grid item xs style={{ textAlign: 'center', marginTop: 10 }}>
                <Link to='/' ><Button style={{ color: "white",fontSize:fNormal,backgroundColor: '#8dc63f' }} color="primary" size="large" variant="contained"   >
                  {t('trial.back')}
                            </Button>
                </Link>
              </Grid>
            </Grid>
          </div>) : false
          }
        </div>

      </div>
    );
  }
}

Trial.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(Trial));
